import transform from '@nerdwallet/transform';

const schema = {
  creditScoreFilter: {
    value: 'inputs.creditScoreRangeValue',
    whitelist: {
      '720-850': 720,
      '690-719': 690,
      '630-689': 630,
      '350-629': 350,
    },
  },
  annualIncomeFilter: 'inputs.income',
  stateFilter: 'inputs.purchaseAddress.state',
};

export default (data) => transform(schema, data);
